import { getWorkflow } from './read'

export const workflow = {
  read: getWorkflow,
}
